import React, { useState } from 'react';
import { Globe } from 'lucide-react';

const Header = ({ currentLang, setCurrentLang, translations }) => {
  const [isLangOpen, setIsLangOpen] = useState(false);
  
  const languages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'uk', name: 'Українська', flag: '🇺🇦' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header-main">
      <div className="container">
        <div className="header-content">
          <div className="logo-section">
            <img 
              src="https://atom-logos.fr/logo.png" 
              alt="ATOM LOGOS" 
              className="logo"
            />
          </div>
          
          <nav className="nav-links">
            <button onClick={() => scrollToSection('services')} className="nav-link">
              {translations.nav.services}
            </button>
            <button onClick={() => scrollToSection('about')} className="nav-link">
              {translations.nav.about}
            </button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">
              {translations.nav.contact}
            </button>
          </nav>

          <div className="language-selector">
            <button 
              className="lang-button"
              onClick={() => setIsLangOpen(!isLangOpen)}
            >
              <Globe size={20} />
              <span className="current-lang">
                {languages.find(l => l.code === currentLang)?.flag}
              </span>
            </button>
            
            {isLangOpen && (
              <div className="lang-dropdown">
                {languages.map(lang => (
                  <button
                    key={lang.code}
                    className={`lang-option ${currentLang === lang.code ? 'active' : ''}`}
                    onClick={() => {
                      setCurrentLang(lang.code);
                      setIsLangOpen(false);
                    }}
                  >
                    <span className="lang-flag">{lang.flag}</span>
                    <span className="lang-name">{lang.name}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
